<!-- Button -->
<button
    mat-icon-button
    [matMenuTriggerFor]="userActions">
    <span class="relative flex items-center justify-center">
        <ng-container *ngIf="user?._avatar?.url as avatarUrl; else initialsOrIcon">
            <img
                [src]="avatarUrl"
                alt="Avatar"
                class="w-8 h-8 rounded-full object-cover" />
            <!-- Color badge -->
            <div
                class="absolute bottom-0 right-0 w-3 h-3 rounded-full border-2 border-white dark:border-gray-800"
                [style.backgroundColor]="user?.color || '#424242'">
            </div>
        </ng-container>
        <ng-template #initialsOrIcon>
            <ng-container *ngIf="user?.firstName && user?.lastName; else defaultIcon">
                <div
                    class="w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold text-white"
                    [style.backgroundColor]="user?.color || '#424242'">
                    {{ getInitials(user!) }}
                </div>
            </ng-container>
            <ng-template #defaultIcon>
                <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
            </ng-template>
        </ng-template>
        <!-- Status indicator -->
        <div
            *ngIf="user"
            class="absolute -bottom-0.5 -right-0.5 w-2.5 h-2.5 rounded-full border-2 border-white dark:border-gray-800"
            [ngClass]="getStatusColor(getUserStatus(user))">
        </div>
    </span>
</button>

<mat-menu
    [xPosition]="'before'"
    #userActions="matMenu">
    <button mat-menu-item>
        <span class="flex flex-col leading-none">
            <span>Connecté en tant que</span>
            <span class="mt-1.5 text-md font-medium">{{(user$ | async )?.firstName}} {{(user$ | async )?.lastName}} ({{(user$ | async )?.email}})</span>
        </span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item [routerLink]="['/profile']">
        <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        <span>Profil</span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <button
        mat-menu-item
        (click)="signOut()">
        <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon>
        <span>Déconnexion</span>
    </button>
</mat-menu>
